import styled, { css } from "styled-components";

export const RollOverContainer = styled.section`
	display: grid;
	grid-template-areas: "a a .";
	overflow-x: scroll;
	grid-gap: 0.75rem;
	grid-template-columns: repeat(auto-fill, calc(100vw * 0.36));
	grid-auto-flow: column dense;
	padding: 0 0 0 0.75rem;
	height: fit-content;

	&::-webkit-scrollbar {
		display: none;
	}

	a {
		display: flex;
		width: calc(100vw * 0.36);
		flex: 0 0 calc(100vw * 0.36);
		border-radius: 0.5rem;
		img {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: inherit;
		}
	}

	@supports not (display: grid) {
		display: flex;
		grid-gap: 0;

		a {
			margin-right: 0.75rem;
		}
	}
`;

export const CardBannerContainer = styled.section`
	display: flex;
	overflow: hidden;
`;

export const SingleSlidingWrap = styled(RollOverContainer).withConfig({
	shouldForwardProp: (prop) => !["cardWidth"].includes(prop),
})<{ cardWidth: string }>`
	${(props: { cardWidth: string }) => {
		const cardWidth = props.cardWidth || "48vw";
		return css`
			grid-template-columns: repeat(auto-fill, calc(${cardWidth}));

			a {
				width: calc(${cardWidth});
				flex: 0 0 calc(${cardWidth});
			}
		`;
	}}
`;
export const ViewMoreBox = styled.a`
	align-items: center;
	justify-content: center;
	flex-direction: column;
	border-radius: 0.5rem;
	opacity: 0.8;
	background: #ffffff;
	margin-bottom: 0;
	position: relative;
`;
